import HttpService from "@core/services/http/http.service";
import {
  Category,
  CreateCategory,
  DropdownCategory,
  GetAllResponse,
  GetListResponse,
} from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _CategoryService {
  public getAll() {
    return HttpService.get<GetAllResponse<Category>>(
      "/user/api/v1/categories/all"
    );
  }

  public getList(
    requestParams?: RequestParams,
    signal?: Signal,
    isShowLoading?: boolean
  ) {
    return HttpService.get<GetListResponse<Category>>(
      "/admin/api/v1/categories",
      {
        queryParams: { ...requestParams },
        signal,
        isShowLoading,
      }
    );
  }

  public create(category: CreateCategory) {
    return HttpService.post("/admin/api/v1/categories", {
      body: { ...category },
    });
  }

  public update(categoryId: number, category: CreateCategory) {
    return HttpService.patch(`/admin/api/v1/categories/${categoryId}`, {
      body: { ...category },
    });
  }

  public delete(categoryId: number) {
    return HttpService.delete(`/admin/api/v1/categories/${categoryId}`);
  }

  public getDropdown(requestParams?: RequestParams) {
    return HttpService.get<GetListResponse<DropdownCategory>>(
      "/admin/api/v3/categories/dropdown",
      {
        queryParams: { ...requestParams },
      }
    );
  }
}

const CategoryService = new _CategoryService();

export default CategoryService;
